import { __assign } from "tslib";
import { defaultFieldResolver } from 'graphql';
import { mapSchema, MapperKind, getDirectives } from '@graphql-tools/utils';
export function attachDirectiveResolvers(schema, directiveResolvers) {
    var _a;
    if (typeof directiveResolvers !== 'object') {
        throw new Error("Expected directiveResolvers to be of type object, got " + typeof directiveResolvers);
    }
    if (Array.isArray(directiveResolvers)) {
        throw new Error('Expected directiveResolvers to be of type object, got Array');
    }
    return mapSchema(schema, (_a = {},
        _a[MapperKind.OBJECT_FIELD] = function (fieldConfig) {
            var newFieldConfig = __assign({}, fieldConfig);
            var directives = getDirectives(schema, fieldConfig);
            Object.keys(directives).forEach(function (directiveName) {
                if (directiveResolvers[directiveName]) {
                    var resolver_1 = directiveResolvers[directiveName];
                    var originalResolver_1 = newFieldConfig.resolve != null ? newFieldConfig.resolve : defaultFieldResolver;
                    var directiveArgs_1 = directives[directiveName];
                    newFieldConfig.resolve = function (source, originalArgs, context, info) {
                        return resolver_1(function () {
                            return new Promise(function (resolve, reject) {
                                var result = originalResolver_1(source, originalArgs, context, info);
                                if (result instanceof Error) {
                                    reject(result);
                                }
                                resolve(result);
                            });
                        }, source, directiveArgs_1, context, info);
                    };
                }
            });
            return newFieldConfig;
        },
        _a));
}
//# sourceMappingURL=attachDirectiveResolvers.js.map